const labels = {
    en: {
        copyRightContentLabel: `Copyright © ${new Date().getFullYear()} Maxis Bhd. All rights reserved.`,
        tncTitle: 'Terms & Policies',
    },
    ms: {
        copyRightContentLabel: `Copyright © ${new Date().getFullYear()} Maxis Bhd. All rights reserved.`,
        tncTitle: 'Terms & Policies',
    }
};
export default labels;
